import { render, staticRenderFns } from "./FireCauseLocalOrigin.vue?vue&type=template&id=68f9d386&scoped=true"
import script from "./FireCauseLocalOrigin.vue?vue&type=script&lang=ts"
export * from "./FireCauseLocalOrigin.vue?vue&type=script&lang=ts"
import style0 from "./FireCauseLocalOrigin.vue?vue&type=style&index=0&id=68f9d386&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f9d386",
  null
  
)

export default component.exports